import { useEffect } from "react";
import { useLocation } from "react-router";
import { applyPageMetadata } from "../seo/metadata";

export function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    applyPageMetadata(pathname);
  }, [pathname]);

  return null;
}
